module.exports = __webpack_public_path__ + "img/the_incible_company.ff4b781e.jpg";